export default __webpack_public_path__ + "static/media/Secretary.91aa674b.jpg";